export default __webpack_public_path__ + "static/media/evangelus.ebbc3ea4.svg";